import { render, staticRenderFns } from "./OrgHomeInventoryCharts.vue?vue&type=template&id=5492a76b&scoped=true&"
import script from "./OrgHomeInventoryCharts.vue?vue&type=script&lang=js&"
export * from "./OrgHomeInventoryCharts.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeInventoryCharts.vue?vue&type=style&index=0&id=5492a76b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492a76b",
  null
  
)

export default component.exports